import { render, staticRenderFns } from "./subcategoriaproductoEdit.vue?vue&type=template&id=1a5db105&scoped=true&"
import script from "./subcategoriaproductoEdit.vue?vue&type=script&lang=js&"
export * from "./subcategoriaproductoEdit.vue?vue&type=script&lang=js&"
import style0 from "./subcategoriaproductoEdit.vue?vue&type=style&index=0&lang=css&"
import style1 from "./subcategoriaproductoEdit.vue?vue&type=style&index=1&id=1a5db105&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5db105",
  null
  
)

export default component.exports